"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onFeaturesReady = exports.preloadFeatureApps = exports.FeatureAppLoader = exports.META_DATA_STORE_KEY = void 0;
const React = __importStar(require("react"));
const oneaudi_os_utils_1 = require("@oneaudi/oneaudi-os-utils");
const oneaudi_os_store_1 = __importDefault(require("@oneaudi/oneaudi-os-store"));
const loader_1 = require("./loader");
const useDynamicFeature_1 = require("./useDynamicFeature");
const ErrorBoundary_1 = require("./ErrorBoundary");
const url_1 = require("./url");
const useInternalMetaData_1 = require("./useInternalMetaData");
exports.META_DATA_STORE_KEY = 'metaDataContext';
exports.FeatureAppLoader = React.memo(({ src, name, version, sharedModule = './App', loader = null, fallback, ...rest }) => {
    const parent = (0, useInternalMetaData_1.useInternalMetaData)();
    let appName = name && (0, oneaudi_os_utils_1.camelToDash)(name);
    const featureAppRemoteUrl = (0, url_1.autoFixFeatureAppUrl)(src || (0, url_1.constructUrl)({ appName, version }));
    // Being prepared to use the app-name extracted from remote url source
    const parts = (0, url_1.getFeatureAppUrlParts)(featureAppRemoteUrl);
    if (!name) {
        // If appName is not supplied then figure it out from the remote url source
        if (parts && parts.name) {
            appName = (0, oneaudi_os_utils_1.camelToDash)(parts.name);
        }
        else {
            // Looks like we couldn't resolve the name
            throw Error('Cannot resolve app name');
        }
    }
    // Try to retrieve feature app from the cache
    const CachedFeatureApp = (0, loader_1.getCachedModule)(appName, sharedModule);
    const status = (0, useDynamicFeature_1.useDynamicFeature)(featureAppRemoteUrl, !!CachedFeatureApp);
    // Create a globally unique React Context in 'store' so that all Feature Apps use the same
    // Context reference regardless of the oneaudi-os-react package version.
    if (!oneaudi_os_store_1.default.has(exports.META_DATA_STORE_KEY)) {
        oneaudi_os_store_1.default.add(exports.META_DATA_STORE_KEY, React.createContext(null));
    }
    const MetaData = oneaudi_os_store_1.default.get(exports.META_DATA_STORE_KEY);
    MetaData.displayName = 'MetaData';
    if (CachedFeatureApp) {
        return (React.createElement(ErrorBoundary_1.ErrorBoundary, { src, appName, sharedModule, parent, ...rest },
            React.createElement(MetaData.Provider, { value: { ...{ src, name, version, sharedModule, parent, ...rest } } },
                React.createElement(CachedFeatureApp, { ...rest }))));
    }
    if (status === 'error') {
        if (fallback) {
            return React.createElement(React.Fragment, null, fallback);
        }
        return process.env.NODE_ENV === 'development' ? (React.createElement("h2", null,
            "Failed to load feature ",
            React.createElement("i", null, appName),
            " from ",
            featureAppRemoteUrl)) : null;
    }
    if (status === 'ready') {
        // Cache failed, but the module loaded asynchronously. Time to async-load and show
        const Component = React.lazy(() => (0, loader_1.loadFeatureApp)(appName, parts && parts.name ? `${(0, oneaudi_os_utils_1.camelToDash)(parts.name)}-docs` : '', sharedModule));
        return (React.createElement(ErrorBoundary_1.ErrorBoundary, { src, appName, sharedModule, parent, ...rest },
            React.createElement(React.Suspense, { fallback: loader },
                React.createElement(MetaData.Provider, { value: {
                        ...{ src, name, version, sharedModule, parent, ...rest },
                    } },
                    React.createElement(Component, { ...rest, app: { name: appName, url: src, version, sharedModule } })))));
    }
    // Idle....
    return process.env.NODE_ENV === 'development' ? (React.createElement("h2", null,
        "Loading feature ",
        React.createElement("i", null, appName),
        " from ",
        featureAppRemoteUrl)) : null;
});
function preloadFeatureApps() {
    const apps = window.__PRELOAD_FEATURES__ || {};
    const thenables = Object.values(apps).map(([name, sharedModule]) => (0, loader_1.loadFeatureApp)(name, '', sharedModule, true));
    return Promise.all(thenables);
}
exports.preloadFeatureApps = preloadFeatureApps;
async function onFeaturesReady(cb) {
    // First ensure all Feature Apps are pre-loaded and intialized
    await preloadFeatureApps();
    // We are all done so let's proceed
    cb();
}
exports.onFeaturesReady = onFeaturesReady;
